/** Default USD line when balance is zero or unavailable (2 decimals). */
export const HEADER_USD_ZERO = '$0.00';

export function formatHeaderUsd2(amount: number | null | undefined): string {
  const n = amount ?? 0;
  if (!Number.isFinite(n) || n === 0) return HEADER_USD_ZERO;
  return `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
